import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { endPoints } from "../../../constant/Environment";
import { getAllData } from "../../../Utility/API";

import ActionListSearch from "../../../components/FilterComponent/ActionListSearch";


function getNumberOfPages(rowCount, rowsPerPage) {
  return Math.ceil(rowCount / rowsPerPage);
}

function toPages(pages) {
  const results = [];
  for (let i = 1; i <= pages; i++) {
    results.push(i);
  }

  return results;
}
const columns = [
  {
    name: "Id",
    selector: (row) => row.idHistorical,
    sortable: true,
  },
  {
    name: "Session ID",
    selector: (row) => row.idSessione,
    sortable: true,
  },
  {
    name: "User",
    selector: (row) => row.login,
    sortable: true,
  },
  {
    name: "Involved user",
    selector: (row) => row.login,
    sortable: true,
  },
  {
    name: "Event type",
    selector: (row) => row.eventType,
    sortable: true,
  },
  {
    name: "Insert at",
    selector: (row) => row.insertionTime,
    sortable: true,
  },
  {
    name: "Description",
    selector: (row) => row.description,
    sortable: true,
  },
  {
    name: "Balance",
    selector: (row) => row.preactionBalance,
    sortable: true,
  },

];

// RDT exposes the following internal pagination properties
const BootyPagination = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  onChangeRowsPerPage, // available but not used here
  currentPage
}) => {
  const handleBackButtonClick = () => {
    onChangePage(currentPage - 1);
  };

  const handleNextButtonClick = () => {
    onChangePage(currentPage + 1);
  };

  const handlePageNumber = (e) => {
    onChangePage(Number(e.target.value));
  };

  const pages = getNumberOfPages(rowCount, rowsPerPage);
  const pageItems = toPages(pages);
  const nextDisabled = currentPage === pageItems.length;
  const previosDisabled = currentPage === 1;

  return (
    <nav>
      <ul className="pagination">
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleBackButtonClick}
            disabled={previosDisabled}
            aria-disabled={previosDisabled}
            aria-label="previous page"
          >
            Previous
          </button>
        </li>
        {pageItems.map((page) => {

          const className =
            page === currentPage ? "page-item active" : "page-item";

          return (
            <li key={page} className={className}>
              <button
                className="page-link"
                onClick={handlePageNumber}
                value={page}
              >
                {page}
              </button>
            </li>
          );
        })}
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleNextButtonClick}
            disabled={nextDisabled}
            aria-disabled={nextDisabled}
            aria-label="next page"
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

const ActionList = () => {
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const filteredItems = rows.filter(
    (item) =>
      item.login && item.login.toLowerCase().includes(filterText.toLowerCase())
  );



  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    let url = `${endPoints.api.GET_Action_List}`;
    await getAllData(url)
      .then((response) => {

        if (response.status === "success") {
          setRows(response.data);
          setPending(false);
          console.log("data", response.data);
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      <div className="main">
        <div id="Sportbook" style={{ padding: '0px' }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="mb-2">Action List</h2>
                </div>
              </div>

              <div
                className="row"
                style={{ padding: "5px 0px 20px 0px" }}
              >
                <div className="col-md-12">
                  <ActionListSearch />
                </div>
                <div className="container-fluid table-custom">
                  <div className="col-md-12">
                    <DataTable
                      className="c_table"
                      title=""
                      columns={columns}
                      data={rows}
                      defaultSortFieldID={1}
                      pagination
                      paginationComponent={BootyPagination}
                      paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                    // subHeader
                    // subHeaderComponent={subHeaderComponentMemo}
                    />

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActionList;
